'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

BaseTwoAxisGraphPanelDirective=class BaseTwoAxisGraphPanelDirective extends BaseControllerBackedDirective{
get controller(){return BaseTwoAxisGraphPanelDirectiveController}
get objectBindings(){return['context','graphYAxisDomain','graphXAxisDomain','preventAnimations']}
get textBindings(){return['yAxisLabel']}
get template(){
return`<svg id="{{::controller.panelId}}"></svg>`;
}};


const MinimumComponentWidth=181;
const MinimumComponentHeight=98;let

BaseTwoAxisGraphPanelDirectiveController=class BaseTwoAxisGraphPanelDirectiveController{
constructor($scope,$timeout,$element,elementService){
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
this._elementService=elementService;
this._svgContainer=null;
this._drawTickLinesOnTopOfGraph=_.get(this,'_drawTickLinesOnTopOfGraph',!1);

this.preventAnimations=_.get(this,'preventAnimations',!1);
this.panelId='panel-'+Guid.create().toString();

this._panelBodyPadding={
top:8,
right:8,
bottom:4,
left:8};

this._axisLabelMargins={
top:4,
right:8,
bottom:18,
left:35};

this._graphAreaInnerPadding={
top:0,
right:0,
bottom:0,
left:8};



this._debouncedRedraw=_.debounce(options=>$timeout(()=>this._redraw(options)),100);

$scope.$on('resize::resize',()=>this._debouncedRedraw({isResizing:!0}));
$scope.$watch('controller.context',(newVal,oldVal)=>{
if(!_.exists(newVal)||newVal===oldVal){
return;
}

this._debouncedRedraw();
});


this._debouncedRedraw();
}

_redraw({isResizing=!1}={}){
if(isResizing||!_.exists(this.graphAreaDimensions)){
this._updateDimensions();

if(isResizing&&_.exists(this.graphAreaDimensions)){
if(this.graphAreaWithMarginDimensions.height===this._lastHeight&&
this.graphAreaWithMarginDimensions.width===this._lastWidth){
return;
}

this._lastHeight=this.graphAreaWithMarginDimensions.height;
this._lastWidth=this.graphAreaWithMarginDimensions.width;
}
}

this.__setupGraphs(isResizing);
this._setupInitialState(isResizing);
this._updateState(isResizing);
}

_setupInitialState(){
throw new Error('Abstract!');
}

_updateState(){
throw new Error('Abstract!');
}

get graphElement(){
return this._graphElement||(this._graphElement=this._elementService.selectElement(this._$element)[0]);
}

_updateDimensions(){
const ComponentWidth=Math.max(MinimumComponentWidth,this.graphElement.clientWidth)-this._panelBodyPadding.left-this._panelBodyPadding.right;
const ComponentHeight=Math.max(MinimumComponentHeight,this.graphElement.clientHeight)-this._panelBodyPadding.top-this._panelBodyPadding.bottom;

this.graphAreaWithMarginDimensions={
height:ComponentHeight,
width:ComponentWidth};


this.graphAreaDimensions={
height:this.graphAreaWithMarginDimensions.height-this._axisLabelMargins.top-this._axisLabelMargins.bottom,
width:this.graphAreaWithMarginDimensions.width-this._axisLabelMargins.left-this._axisLabelMargins.right};

}

__setupGraphs(isResizing){
if(!_.exists(this._svgContainer)){
this._svgContainer=d3.select(`#${this.panelId}`);

this._svgDefs=this._svgContainer.append('defs');

this._graphAreaClipPathRect=this._svgDefs.
append('g').
attr({
class:'clip-path-group',
transform:`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`}).

append('clipPath').
attr({
id:`clip-path-${this.panelId}`}).

append('rect');

this._graphAreaBackground=this._svgContainer.append('rect').
attr({class:'background',transform:`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`});

this._yAxisGroup=this._svgContainer.append('g').
attr({class:'y axis'});

this._xAxisGroup=this._svgContainer.append('g').
attr({class:'x axis'});

this._yAxisLabelGroup=this._svgContainer.append('g').
attr({class:'y axis unit-label'});

this._graphAreaGroup=this._svgContainer.insert('g',this._drawTickLinesOnTopOfGraph?'.y.axis':void 0).
attr({class:'graph-area'}).
attr('transform',`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`);

this._yAxisLabel=this._yAxisLabelGroup.append('text').text(this.yAxisLabel);
}

this._svgContainer.
attr(this.graphAreaWithMarginDimensions).
style('width',`${this.graphAreaWithMarginDimensions.width}px`).
style('height',`${this.graphAreaWithMarginDimensions.height}px`);

this._graphAreaClipPathRect.attr(this.graphAreaDimensions);

this._yScale=d3.scale.linear().
domain(this.graphYAxisDomain).
nice(this._yScaleNiceDomainRounding).
range([this.graphAreaDimensions.height-this._graphAreaInnerPadding.top,this._graphAreaInnerPadding.bottom]).
clamp(!0);

this._xScale=d3.time.scale.utc().
domain(this.graphXAxisDomain).
range([this._graphAreaInnerPadding.left,this.graphAreaDimensions.width-this._graphAreaInnerPadding.right]);

if(_.isFunction(this._setupGraphs)){
this._setupGraphs(isResizing);
}

const graphYAxis=d3.svg.axis().
scale(this._yScale).
orient('left').
ticks(this._numYAxisTicks).
tickPadding(5).
tickSize(this.graphAreaDimensions.width);
this._yAxisGroup.call(graphYAxis);
this._graphAreaBackground.attr(this.graphAreaDimensions);

this._yAxisLabel.attr({
x:0.5*(this.graphAreaDimensions.height-this._axisLabelMargins.bottom),
y:0});


const graphXAxis=d3.svg.axis().
scale(this._xScale).
orient('bottom').
ticks(d3.time.month.utc).
tickPadding(5).
tickFormat(d3.time.format.utc('%b'));
this._xAxisGroup.call(graphXAxis);

this._shiftLayersToCorrectPosition();
}

_shiftLayersToCorrectPosition(){
this._xAxisGroup.
attr({transform:`translate(${this._axisLabelMargins.left},${this.graphAreaDimensions.height})`});

this._yAxisGroup.
attr({transform:`translate(${this.graphAreaDimensions.width+this._axisLabelMargins.left},${this._axisLabelMargins.top})`});

this._yAxisLabelGroup.
attr({transform:`translate(8,${this.graphAreaDimensions.height}),rotate(-90)`});
}

get minComponentWidth(){
return MinimumComponentWidth;
}

get minComponentHeight(){
return MinimumComponentHeight;
}};


module.exports=BaseTwoAxisGraphPanelDirective;
module.exports.DirectiveController=BaseTwoAxisGraphPanelDirectiveController;
//# sourceMappingURL=baseTwoAxisGraphPanelDirective.js.map
